// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as V3i$Linear from "lumi-linear/lib/es6/src/V3i.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_string from "@rescript/runtime/lib/es6/Primitive_string.js";
import * as JsxRuntime from "react/jsx-runtime";

let Color = {
  jsonCodec: V3i$Linear.jsonCodec
};

let pattern = /^[0-9a-z]{8}$/;

function toString(str) {
  return str._0;
}

function fromString(str) {
  if (pattern.test(str)) {
    return {
      TAG: "Address",
      _0: str
    };
  }
}

let jsonCodec = Jzon.custom(str => Jzon.encodeWith(str._0, Jzon.string), json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => LumiOption.okOr(fromString(str), {
  NAME: "UnexpectedJsonValue",
  VAL: [
    [],
    str
  ]
})));

function Types$Address(props) {
  return JsxRuntime.jsx("span", {
    children: props.address._0,
    className: "is-family-monospace"
  });
}

function cmp(a, b) {
  return Primitive_string.compare(a._0, b._0);
}

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

let Address = {
  pattern: pattern,
  toString: toString,
  fromString: fromString,
  jsonCodec: jsonCodec,
  make: Types$Address,
  Cmp: Cmp
};

function toString$1(value) {
  switch (value) {
    case "PortA" :
      return "a";
    case "PortB" :
      return "b";
    case "PortC" :
      return "c";
    case "PortD" :
      return "d";
  }
}

function fromString$1(str) {
  switch (str) {
    case "a" :
      return "PortA";
    case "b" :
      return "PortB";
    case "c" :
      return "PortC";
    case "d" :
      return "PortD";
    default:
      return;
  }
}

let stringCodec = {
  toString: toString$1,
  fromString: fromString$1
};

let jsonCodec$1 = LumiJzon.stringCodec(stringCodec);

let CommsChannel = {
  toString: toString$1,
  fromString: fromString$1,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.object3(param => [
  param.bridge,
  param.channel,
  param.indicator
], param => ({
  TAG: "Ok",
  _0: {
    bridge: param[0],
    channel: param[1],
    indicator: param[2]
  }
}), Jzon.field("bridge", jsonCodec), Jzon.field("channel", jsonCodec$1), Jzon.field("indicator", jsonCodec));

let FullAddress = {
  jsonCodec: jsonCodec$2
};

export {
  Color,
  Address,
  CommsChannel,
  FullAddress,
}
/* jsonCodec Not a pure module */
